/**
 * Глобальний кейборд-стейт + витяг «наміру руху» + одноразові тригери.
 * Розкладку читаємо за `KeyboardEvent.code`, щоб працювало незалежно від мови.
 */
export const keys = new Set();
/** Буфер одноразових подій (натиснув кнопку — поставити прапорець, гра спожиє). */
export const triggers = {
    player1Bomb: false,
    player1Detonate: false,
    pauseToggle: false,
};
export function installKeyboard() {
    addEventListener('keydown', (e) => {
        keys.add(e.code);
        if (e.code === 'Space') {
            triggers.player1Bomb = true;
            e.preventDefault();
        }
        if (e.code === 'KeyQ')
            triggers.player1Detonate = true;
        if (e.code === 'Escape' || e.code === 'KeyP') {
            triggers.pauseToggle = true;
            e.preventDefault();
        }
    });
    addEventListener('keyup', (e) => keys.delete(e.code));
    addEventListener('blur', () => keys.clear());
}
/** Дефолтний біндинг для одиночного гравця. */
export function readPlayer1Intent() {
    let dx = 0, dy = 0;
    if (keys.has('KeyA') || keys.has('ArrowLeft'))
        dx -= 1;
    if (keys.has('KeyD') || keys.has('ArrowRight'))
        dx += 1;
    if (keys.has('KeyW') || keys.has('ArrowUp'))
        dy -= 1;
    if (keys.has('KeyS') || keys.has('ArrowDown'))
        dy += 1;
    return { dx, dy };
}
/** Споживає прапорець (один раз повертає true, потім false). */
export function consumePlaceBomb() {
    const v = triggers.player1Bomb;
    triggers.player1Bomb = false;
    return v;
}
export function consumeDetonate() {
    const v = triggers.player1Detonate;
    triggers.player1Detonate = false;
    return v;
}
export function consumePauseToggle() {
    const v = triggers.pauseToggle;
    triggers.pauseToggle = false;
    return v;
}
/** Тригери (одноразові події). Реєструємо колбек на `keydown` для конкретного коду. */
export function onKey(code, fn) {
    addEventListener('keydown', (e) => { if (e.code === code)
        fn(); });
}
